import { Text } from "iparque-components";
import React from "react";
import CheckboxField from "./index";

interface Props {
  id: string;
  name: string;
  label: string;
  className?: string;
  required?: boolean;
}

const NewsletterCheckboxField: React.FC<Props> = ({
  id,
  name,
  label,
  className,
  required,
}) => {
  return (
    <CheckboxField
      id={id}
      name={name}
      className={className}
      label={
        <Text variant="body8" color="quaternary">
          {label}
          {required && (
            <Text className="inline" variant="body8" color="danger">
              *
            </Text>
          )}
        </Text>
      }
    />
  );
};

export default NewsletterCheckboxField;
